import React, {useState} from 'react';
import { useDrop } from 'react-dnd';
import {Col} from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import moment from 'moment';
import SweetAlert from "react-bootstrap-sweetalert";
import { paramPost } from "../../apiHelpers/commonApiHelper";

const Media = (props) => {

    const [confirm_both, setconfirm_both] = useState(false);
    const [success_dlg, setsuccess_dlg] = useState(false);
    const [error_dlg, seterror_dlg] = useState(false);
    const [dynamic_title, setdynamic_title] = useState("");
    const [dynamic_description, setdynamic_description] = useState("");

    const [fileId, setFileId] = useState(undefined);

    const contentList = () => {
        if (props.media) {
            return props.media.map((item, index) => {
                if(props.contentId === 1) {
                    return (
                        <Tr key={index}>
                            <Td>{item.file_name}</Td>
                            <Td>
                                {item.media_type === "image" ? (
                                    <img src={item.url} style={{width: "85px", height: "60px"}} />
                                ) : item.media_type === "video" ? (
                                    <video style={{width: "85px", height: "60px"}}>
                                        <source src={item.url} type="video/mp4" />
                                    </video>
                                ) : ""}
                            </Td>
                            <Td>{item.media_type}</Td>
                            <Td>{moment(item.created_at).format("llll")}</Td>
                            <Td>
                                <i
                                    className="fas fa-trash-alt"
                                   style={{cursor: "pointer"}}
                                    onClick={() => handleDelete(item.id)}
                                ></i>
                            </Td>
                        </Tr>
                    );
                }
                if(props.contentId === 2) {
                    if(item.media_type === "image") {
                        return (
                            <Tr key={index}>
                                <Td>{item.file_name}</Td>
                                <Td>
                                    <img src={item.url} style={{width: "85px", height: "60px"}} />
                                </Td>
                                <Td>{item.media_type}</Td>
                                <Td>{moment(item.created_at).format("llll")}</Td>
                                <Td>
                                    <i
                                        className="fas fa-trash-alt"
                                        style={{cursor: "pointer"}}
                                        onClick={() => handleDelete(item.id)}
                                    ></i>
                                </Td>
                            </Tr>
                        );
                    }
                }
                if(props.contentId === 3) {
                    if(item.media_type === "video") {
                        return (
                            <Tr key={index}>
                                <Td>{item.file_name}</Td>
                                <Td>
                                    <video style={{width: "85px", height: "60px"}}>
                                        <source src={item.url} type="video/mp4" />
                                    </video>
                                </Td>
                                <Td>{item.media_type}</Td>
                                <Td>{moment(item.created_at).format("llll")}</Td>
                                <Td>
                                    <i
                                        className="fas fa-trash-alt"
                                        style={{cursor: "pointer"}}
                                        onClick={() => handleDelete(item.id)}
                                    ></i>
                                </Td>
                            </Tr>
                        );
                    }
                }
            });
        }
    };

    const handleDelete = (id) => {
        setconfirm_both(true);
        setFileId(id);
    }

    const deleteFile = () => {
        paramPost('/api/v1/remove_file', {id: fileId})
            .then((result) => {
                if(result.status === 200) {
                    setsuccess_dlg(true);
                    setdynamic_title("Deleted");
                    setdynamic_description("File deleted successfully");
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000)
                } else if(result.status === 422) {
                    setdynamic_title("Failed");
                    setdynamic_description("This file is already in use in published campaign");
                    seterror_dlg(true);
                } else {
                    setdynamic_title("Failed");
                    setdynamic_description("Something went wrong. Try again");
                    seterror_dlg(true);
                }
            })
            .catch((err) => {
                setdynamic_title("Error");
                setdynamic_description("Something went wrong. Try again");
                seterror_dlg(true);
            })
    }

    return (
        <div className="table-rep-plugin">
            <div
                className="table-responsive mb-0"
                data-pattern="priority-columns"
            >
                <Table
                    id="tech-companies-1"
                    className="table table-striped table-bordered content-table"
                >
                    <Thead>
                        <Tr>
                            <Th data-priority="1">Name</Th>
                            <Th data-priority="1">File</Th>
                            <Th data-priority="1">Type</Th>
                            <Th data-priority="1">Uploaded Date</Th>
                            <Th data-priority="1">Action</Th>
                        </Tr>
                    </Thead>
                    <Tbody className="">{contentList()}</Tbody>
                </Table>
            </div>

            {confirm_both ? (
                <SweetAlert
                    title={"Are you sure?"}
                    warning
                    showCancel
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => {
                        setconfirm_both(false);
                        deleteFile();
                    }}
                    onCancel={() => {
                        setconfirm_both(false);
                        setsuccess_dlg(false);
                        setdynamic_title("Cancelled");
                        setdynamic_description("Your imaginary file is safe :)");
                    }}
                >
                    Delete this file?
                </SweetAlert>
            ) : null}

            {success_dlg ? (
                <SweetAlert
                    success
                    title={dynamic_title}
                    onConfirm={() => {
                        setsuccess_dlg(false);
                    }}
                >
                    {dynamic_description}
                </SweetAlert>
            ) : null}

            {error_dlg ? (
                <SweetAlert
                    error
                    title={dynamic_title}
                    onConfirm={() => {
                        seterror_dlg(false);
                    }}
                >
                    {dynamic_description}
                </SweetAlert>
            ) : null}

        </div>
    )
};

export default Media
